import UserAccountForm from "../../../components/Form/UserAccount";

const AccountTab = ({
  control,
  errors,
  setValue,
  getValues,
  trigger,
  viewOnly,
  admin,
  onTriggerRevalidate,
  onSubmit,
  setting,
  addable,
  onReset,
  option,
}) => {
  return (
    <>
      <UserAccountForm
        control={control}
        errors={errors}
        setValue={setValue}
        trigger={trigger}
        viewOnly={viewOnly}
        option={option}
        admin={admin}
        getValues={getValues}
        onTriggerRevalidate={onTriggerRevalidate}
        onSubmit={onSubmit}
        setting={setting}
        addable={addable}
        onReset={onReset}
      />
    </>
  );
};

export default AccountTab;
